import { useSyncExternalStore } from "react";
import {
  subscribeComplianceConfig,
  getComplianceConfigVersion,
} from "./complianceCopy";

/**
 * Re-render this component when admin-configured site vocabulary loads.
 *
 * Site settings arrive asynchronously after mount, so a component that reads
 * getTerm() during its first render — or worse, captures a label into useState
 * at mount — would otherwise be stuck on the built-in defaults with nothing to
 * tell React the wording changed.
 *
 * Call this in any component that renders a term. It returns the config
 * version, which is only useful as a dependency; read the actual words through
 * getTerm() as normal.
 */
export const useComplianceConfig = () =>
  useSyncExternalStore(subscribeComplianceConfig, getComplianceConfigVersion);

export default useComplianceConfig;
